import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import ThemeMode from './ThemeMode';
import Close from '../image/close.svg';
import Menu from '../image/menu.svg';
import Footer from './Footer';

const ResponsiveNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className='flex items-center lg:hidden justify-between flex-wrap p-4 font-mono h-[50px] w-full'>
      <div className='flex justify-end lg:hidden w-full'>
        <button className='absolute p-2 z-30 rounded-full bg-white' onClick={handleClick}>
          {isOpen ? (
            <img src={Close} alt='close' width='30px' height='30px' />
          ) : (
            <img src={Menu} alt='menu' width='30px' height='30px' />
          )}
        </button>
      </div>
      <div
        className={`
          bg-[#29819a]
          absolute flex flex-col items-center
          w-full h-full top-0 right-0 gap-6 pt-[50%] pb-5
          rounded z-20
          text-sm transform transition-transform duration-500  ${
            isOpen ? 'overflow-hidden translate-y-0' : 'translate-y-[-100%]'
          }`}
      >
        <Link to='/' className='text-lg'>Home</Link>
        <hr className='border-4 border-[#dbdada40] w-[50%] rounded' />
        <Link to='/contact' className='text-lg'>Contact</Link>
        <hr className='border-4 border-[#dbdada40] w-[50%] rounded' />
        <Link to='/project' className='text-lg'>Projects</Link>
        <hr className='border-4 border-[#dbdada40] w-[50%] rounded' />
        <ThemeMode />
        <Footer />
      </div>
    </nav>
  );
};

export default ResponsiveNav;
